import React, { useCallback, useMemo } from "react";
import Moment from "moment";
import {shallowEqual, useSelector} from "react-redux";
import i18next from "i18next";

const PrintDate = (props) => {
    /**
     * use Example
     * <PrintDate
     *    tag="span"
     *    attributes={{ class: "date", alias: "test" }}
     *    target={board.reg_date}
     *    reserve= true/false, undefined
     *    />
     */

    // stationInfo 조회
    const { stationInfo } = useSelector((state) => state.stationReducer, shallowEqual);
    const { data, startTime } = stationInfo;
    const { current_timestamp: serverTime } = data;

    const handleConvertDate = useCallback((targetTime, serverTime) => {
        
        // 예약 업로드일 경우 YYYY.MM.DD hh:mm [게시 예정] 으로 표기
        if(props.reserve) return Moment(targetTime).format("YYYY.MM.DD HH:mm") + " " + i18next.t("[게시 예정]");


        // 게시글 등록일이 현재 시간 기준으로 24시간 이내일 경우 ~ 시간 전 으로 표기
        const target_ms = new Date(targetTime).getTime();
        // api서버시간 기준이라 탭이동해도 시간이 업데이트 안되는 이슈 개선
        const server_ms = new Date(serverTime).getTime() + Date.now() - startTime;

        /*
         * getTime() return ms / 1000ms = 1s
         * 1000 * 60 * 60 * 24 = 1day (86,400,000ms)
         */

        // 하루 이내일 경우에는 분/시간 단위로 표기
        if (target_ms >= server_ms - 86400000) {

            /**
             * 0s ~ 60s = 1분
             * 61s ~ 120s = 1분
             * 121s ~ 180 = 2분
             * 3481s ~ 3540s = 58분
             * 3541s ~ 3600s = 59분
             * 3601s = 1시간
             */

            let duringSecond = ((server_ms - target_ms) / 1000);
            let duringMinutes = 1;

            if (duringSecond <= 3600) {

                // 0~120초 1분 / 121~180초 2분 / 181~240 3분
                if (121 <= duringSecond) {
                    duringMinutes = (duringSecond - 1) / 60 ;
                }

                return i18next.t("{{N}}분 전", { N : Math.floor(duringMinutes) });
            }

            // 한시간 이후일 경우 시간으로 표기
            return i18next.t("{{N}}시간 전", { N : Math.floor(duringSecond / (60 * 60)) });
        }

        return Moment(targetTime).format("YYYY-MM-DD");

    }, [props.reserve]);

    const returnDom = useMemo(() => {
        if (props.tag) {
            return React.createElement(props.tag, props.attributes, handleConvertDate(props.target, serverTime));
        } else {
            return handleConvertDate(props.target, serverTime);
        }

    },[props, serverTime, handleConvertDate]);


    return (
        returnDom
    );

}

export default PrintDate;
